<div class="container" *ngIf="!property && !loaded">
    <div class="row justify-content-center mt-5 mb-5">
        <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
    </div>
</div>
<div class="container" *ngIf="property">
    <div class="main-property">
        <div id="property-title" class="mb-5 position-relative">
            <div class="title-of-ad w-100">
                <h2>
                    {{ property.title }}
                </h2>
            </div>
            <button (click)="editOtherFacilities()" mat-stroked-button class="edit-button">
                <mat-icon>edit</mat-icon>
                Edit
            </button>
        </div>
        <div class="gallery position-relative mt-5 mb-5">
            <div class="w-100" *ngIf="galleryImages.length == 0">
                <h1>Gallery</h1>
            </div>
            <div class="w-100" *ngIf="galleryImages.length > 0">
                <ngx-gallery [options]="galleryOptions" [(images)]="galleryImages" class="ngx-gallery"></ngx-gallery>
            </div>
            <button (click)="updateImages()" mat-stroked-button class="edit-button">
                <mat-icon>add</mat-icon>
                Add
            </button>
            <div class="row" *ngIf="galleryImages.length == 0">
                <div class="col-sm-12">
                    <p class="info-text">No images to preview. Click on Add button to add images to gallery.</p>
                </div>
            </div>
        </div>
        <div id="property-info" class="position-relative">
            <button (click)="editBasicInfo()" mat-stroked-button class="edit-button">
                <mat-icon>edit</mat-icon>
                Edit
            </button>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <div class="feature-text mb-5">
                        <div class="row">
                            <div class="col-4">
                                <strong>I am</strong>
                            </div>
                            <div class="col-8">
                                <span>: {{ property.iam }}</span>
                            </div>
                            <div class="col-4">
                                <strong>List For</strong>
                            </div>
                            <div class="col-8">
                                <span>: {{ property.listingFor }}</span>
                            </div>
                            <div class="col-4">
                                <strong>Property Id</strong>
                            </div>
                            <div class="col-8">
                                <span>: {{ property.aliasId }}</span>
                            </div>
                            <div class="col-4" *ngIf="property.totalArea">
                                <strong>Total Area</strong>
                            </div>
                            <div class="col-8" *ngIf="property.totalArea">
                                <span>: {{ property.totalArea }} (Bigha)</span>
                            </div>
                            <div class="col-4" *ngIf="property.houseArea">
                                <strong>Property Area</strong>
                            </div>
                            <div class="col-8" *ngIf="property.houseArea">
                                <span>: {{ property.houseArea }} (Ropani)</span>
                            </div>
                            <div class="col-4" *ngIf="property.floor">
                                <strong>Number of Floors</strong>
                            </div>
                            <div class="col-8" *ngIf="property.floor">
                                <span>: {{ property.floor }}</span>
                            </div>
                            <div class="col-4" *ngIf="property.distFromRoad">
                                <strong>Distance</strong>
                            </div>
                            <div class="col-8" *ngIf="property.distFromRoad">
                                <span>: {{ property.distFromRoad }} from main road</span>
                            </div>
                            <div class="col-4">
                                <strong>Price</strong>
                            </div>
                            <div class="col-8">
                                <span>: NPR {{ property.price }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="description position-relative">
                        <h4 class="pb-3"><strong>Property Description</strong></h4>
                        <div [innerHTML]="property.details"></div>
                        <button (click)="editOtherFacilities()" mat-stroked-button class="edit-button">
                            <mat-icon>edit</mat-icon>
                            Edit
                        </button>
                    </div>
                    <div class="facilities">
                        <h4 class="pt-5 pb-4"><strong>Facilites and Amneties</strong></h4>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.electricity == 'Available'">
                                <div class="facility-inner">
                                    <img src="assets/electricity.png"> Electricity
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.waterSupply == 'Available'">
                                <div class="facility-inner">
                                    <img src="assets/water-supply.png"> Water Supply
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.gasSupply == 'Available'">
                                <div class="facility-inner">
                                    <img src="assets/gas-supply.png"> Gas Supply
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.telecommunication == 'Available'">
                                <div class="facility-inner">
                                    <img src="assets/telecommunication.png"> Telecommunication
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12 facility mb-4" *ngIf="property.parking == 'Available'">
                                <div class="facility-inner">
                                    <img src="assets/sign.png"> Parking
                                </div>
                            </div>
                        </div>
                        <div class="other-facilities pb-5" *ngIf="otherFacilities.length > 0">
                            <h4 class="pt-4 pb-4"><strong>Additional Facilities</strong></h4>
                            <div class="w-100" *ngFor="let facility of otherFacilities">
                                {{ facility.title }} : <span class="ml-3">{{ facility.details }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section>
            <div class="prop-details position-relative" id="map-section">
                <section>
                    <h4 class="text-center mt-5 mb-4"><strong>Location</strong></h4>
                    <!-- <div class="row mb-3">
                        <div class="form-group col-md-8 mt-2 mb-2">
                            <input #location placeholder="Origin" class="form-control">
                        </div>
                        <div class="form-group col-md-4 mt-2 mb-2">
                            <select [(ngModel)]="selectedMode" (ngModelChange)="calcRoute()">
                                <option value="DRIVING">Driving</option>
                                <option value="WALKING">Walking</option>
                                <option value="BICYCLING">Bicycling</option>
                                <option value="TRANSIT">Transit</option>
                                </select>
                        </div>
                    </div> -->
                    <div class="row justify-content-center mt-5 mb-5" *ngIf="!mapLoaded">
                        <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
                    </div>
                    <div class="user-location-map" #mapContainer id="map"></div>
                    <div class="directions" #directionsPanel id="directionsPanel"></div>
                </section>
                <button (click)="editLocationInfo()" mat-stroked-button class="edit-button">
                    <mat-icon>edit</mat-icon>
                    Edit
                </button>
            </div>
        </section>
    </div>
</div>
<div class="container mb-5" *ngIf="bankPayment">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <div class="row justify-content-between ml-2 mr-2">
                        <h4 class="card-title mt-0">Voucher Payment</h4>
                        <div>
                            <button (click)="editPaymentInfo()" mat-button><mat-icon>edit</mat-icon> Update</button>
                            <button (click)="deletePayment(bankPayment.id)" mat-button><mat-icon>delete</mat-icon> Delete</button>
                        </div>
                    </div>     
                </div>
                <div class="card-body">
                    <div class="payment-holder row rounded shadow-lg no-gutters">
                        <div class="col-sm-3">
                            <img class="preview-image" (click)="previewImage(bankPayment.image)" [src]="bankPayment.image" aria-labelledby="Voucher Image">
                        </div>
                        <div class="col-sm-4">
                            <ul>
                                <li><strong>Plan: </strong><span class="content">{{ bankPayment.plan }}</span></li>
                                <li><strong>Amount: </strong><span class="content">{{ bankPayment.amount }}</span></li>
                                <li><strong>Verification: </strong><span class="content"><mat-slide-toggle disabled [(ngModel)]="bankPayment.status"></mat-slide-toggle></span></li>
                            </ul>           
                        </div>
                        <div class="col-sm-5">
                            <p><strong>Remarks:</strong><br><span>{{ bankPayment.remarks }}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container mb-5" *ngIf="transaction">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <div class="row justify-content-between ml-2 mr-2">
                        <h4 class="card-title mt-0">Transaction Information</h4>
                        <div>
                            <button (click)="editPaymentInfo()" mat-button><mat-icon>edit</mat-icon> Update</button>
                            <button (click)="deleteTransaction(transaction.id)" mat-button><mat-icon>delete</mat-icon> Delete</button>
                        </div>
                    </div>   
                </div>
                <div class="card-body">
                    <div class="payment-holder row rounded shadow-lg no-gutters">
                        <div class="col-sm-6">
                            <ul>
                                <li><strong>Transaction Method </strong><span class="content">{{ transaction.paymentMethod }}</span></li>
                                <li><strong>Plan: </strong><span class="content">{{ transaction.plan }}</span></li>
                                <li><strong>Amount: </strong><span class="content">{{ transaction.amount }}</span></li>
                            </ul> 
                        </div>
                        <div class="col-sm-6">
                            <ul>
                                <li><strong>Reference Id: </strong><span class="content">{{ transaction.transaction_id }}</span></li>
                                <li><strong>Verification: </strong><span class="content"><mat-slide-toggle disabled [(ngModel)]="transaction.status"></mat-slide-toggle></span></li>
                            </ul>           
                        </div>
                        <div class="col-sm-12 mb-2" *ngIf="transaction.image">
                            <img class="preview-image" (click)="previewImage(transaction.image)" [src]="transaction.image" aria-labelledby="Voucher Image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
